import { Stack, Typography } from '@mui/joy'
import { useTranslation } from 'react-i18next'
import { Button } from '~/shared/ui/Buttons'
import { RefreshWhiteIcon } from '~/shared/ui/Icons'
import { Modal } from '~/shared/ui/Modal'

type TransactionStornoWarningModalProps = {
  isShow: boolean
  onCancel: () => void
  onOk: () => void
  isSubmitting: boolean
}

export function TransactionStornoWarningModal({
  isShow,
  onCancel,
  onOk,
  isSubmitting,
}: TransactionStornoWarningModalProps) {
  const { t } = useTranslation()

  return (
    <Modal
      isShow={isShow}
      onCancel={!isSubmitting ? onCancel : undefined}
      title={t('button.transaction reversal')}
      modalProps={{
        'data-testid': 'storno-modal',
      }}
    >
      <Typography
        sx={{
          marginBottom: '24px',
        }}
      >
        {t('alert.are you sure you want to cancel the transaction')}
      </Typography>

      <Stack direction='row' justifyContent='space-between' spacing={2}>
        <Button
          variant='gray'
          fullWidth
          onClick={onCancel}
          disabled={isSubmitting}
        >
          {t('button.cancel')}
        </Button>
        <Button
          variant='brand'
          fullWidth
          startDecorator={<RefreshWhiteIcon />}
          onClick={onOk}
          loading={isSubmitting}
        >
          {t('button.cancel transaction')}
        </Button>
      </Stack>
    </Modal>
  )
}
